var map = {
	"./tokens-blue.css": [
		664,
		869,
		664
	],
	"./tokens-green.css": [
		3587,
		869,
		587
	],
	"./tokens-orange.css": [
		4117,
		869,
		498
	],
	"./tokens-purple.css": [
		7550,
		869,
		550
	],
	"./tokens-red.css": [
		9251,
		869,
		251
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2245;
module.exports = webpackAsyncContext;